import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { fontSizeCss, fontWeightNumeric, lineHeight, letterSpacingCss } from '@digiwedge/ui-tokens';
// Mapping of heading variants to their CSS classes from global.css
const headingVariantClasses = {
    h1: 'heading-1',
    h2: 'heading-2',
    h3: 'heading-3',
    h4: 'heading-4',
};
// Mapping of text variants to their CSS classes from global.css
const textVariantClasses = {
    'body-large': 'body-large',
    body: 'body',
    'body-small': 'body-small',
    caption: 'caption',
};
const headingVariantStyles = {
    h1: {
        fontSize: fontSizeCss['5xl'],
        fontWeight: fontWeightNumeric.bold,
        lineHeight: lineHeight.tight,
        letterSpacing: letterSpacingCss.tight,
    },
    h2: {
        fontSize: fontSizeCss['4xl'],
        fontWeight: fontWeightNumeric.bold,
        lineHeight: lineHeight.tight,
        letterSpacing: letterSpacingCss.tight,
    },
    h3: {
        fontSize: fontSizeCss['3xl'],
        fontWeight: fontWeightNumeric.semibold,
        lineHeight: lineHeight.snug,
        letterSpacing: letterSpacingCss.normal,
    },
    h4: {
        fontSize: fontSizeCss['2xl'],
        fontWeight: fontWeightNumeric.semibold,
        lineHeight: lineHeight.snug,
        letterSpacing: letterSpacingCss.normal,
    },
};
const textVariantStyles = {
    'body-large': {
        fontSize: fontSizeCss.xl,
        fontWeight: fontWeightNumeric.normal,
        lineHeight: lineHeight.relaxed,
        letterSpacing: letterSpacingCss.normal,
    },
    body: {
        fontSize: fontSizeCss.lg,
        fontWeight: fontWeightNumeric.normal,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacingCss.normal,
    },
    'body-small': {
        fontSize: fontSizeCss.md,
        fontWeight: fontWeightNumeric.normal,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacingCss.normal,
    },
    caption: {
        fontSize: fontSizeCss.sm,
        fontWeight: fontWeightNumeric.normal,
        lineHeight: lineHeight.normal,
        letterSpacing: letterSpacingCss.normal,
    },
};
/**
 * Heading component with typography variants
 * Uses the custom typography scale defined in global.css
 */
export const Heading = ({ variant, className = '', as, children, style, ...props }) => {
    // Default the HTML element to match the variant if not specified
    const Component = as || variant;
    const classes = twMerge(headingVariantClasses[variant], className);
    const mergedStyle = {
        ...headingVariantStyles[variant],
        ...style,
    };
    return (_jsx(Component, { className: classes, style: mergedStyle, ...props, children: children }));
};
/**
 * Text component with typography variants
 * Uses the custom typography scale defined in global.css
 */
export const Text = ({ variant = 'body', className = '', as = 'p', children, style, ...props }) => {
    const Component = as;
    const classes = twMerge(textVariantClasses[variant], className);
    const mergedStyle = {
        ...textVariantStyles[variant],
        ...style,
    };
    return (_jsx(Component, { className: classes, style: mergedStyle, ...props, children: children }));
};
//# sourceMappingURL=Typography.js.map